
const MobileProcessSection = () => {
  const steps = [
    {
      number: '1',
      title: 'Book a Consultation',
      description: "We'll review your team's mobile needs and requirements."
    },
    {
      number: '2',
      title: 'Choose Your Plan',
      description: 'Select from current T-Mobile business packages that fit your needs.'
    },
    {
      number: '3',
      title: 'Get Onboarded',
      description: "We'll handle setup, number porting, and device delivery."
    },
    {
      number: '4',
      title: 'Ongoing Support',
      description: 'We stay with you post-activation to ensure everything works perfectly.'
    }
  ];

  return (
    <section className="py-20 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4">
            How It Works
          </h2>
          <p className="text-lg text-gray-600 max-w-3xl mx-auto">
            Our streamlined process gets your business connected quickly and efficiently.
          </p>
        </div>
        
        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-8">
          {steps.map((step, index) => (
            <div key={step.number} className="text-center relative">
              {index < steps.length - 1 && (
                <div className="hidden lg:block absolute top-8 left-1/2 w-full h-0.5 bg-purple-200 transform translate-x-1/2"></div>
              )}
              <div className="w-16 h-16 bg-purple-600 text-white rounded-full flex items-center justify-center mx-auto mb-4 relative z-10 text-xl font-bold">
                {step.number}
              </div>
              <h3 className="text-xl font-semibold text-gray-900 mb-2">
                {step.title}
              </h3>
              <p className="text-gray-600">
                {step.description}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default MobileProcessSection;
